@if (config?.title) {
  <h3 class="mb-8">{{ config.title }}</h3>
}

@if (config) {
  <div
    class="timeline"
    [style.--days]="days.length"
    [style.--items]="activities.length"
    [style.--zoom]="zoom + 'px'"
    >
    <div class="timeline__head">
      <div class="activity__description"></div>
      @for (activity of activities; track activity) {
        <div
          class="activity__description"
          >
          @for (singleActivity of activity.data; track singleActivity) {
            <p>
              {{ singleActivity.description }} {{ singleActivity.subDescription }}
            </p>
          }
        </div>
      }
    </div>
    <div
      class="timeline__body"
      #timelineBody
      [disableDrag]="false"
      appScrollDrag
      >
      <div class="units">
        @for (day of [].constructor(days.length); track day; let i = $index) {
          @for (hour of [].constructor(24); track hour; let j = $index) {
            <div
              class="unit"
              >
              @if (j === 0) {
                <h3
                  class="date"
                  >
                  {{ days[i] | date: "dd/MM/yyyy" }}
                </h3>
              }
              @if (shouldShowHour(j)) {
                <span class="time"> {{ j }}h </span>
              }
              <div class="unit__minutes">
                @for (minute of [].constructor(60); track minute; let m = $index) {
                  <div
                    class="unit__minute"
                  ></div>
                }
              </div>
            </div>
          }
        }
      </div>
      @for (activity of activities; track activity) {
        <div
          class="activity__grid"
          >
          @for (data of activity.data; track data) {
            <div
              class="activity__grid__item"
              [pTooltip]="data.tooltip"
              [style.--color]="data.color"
              [style.--end]="data.endMinute"
              [style.--start]="data.startMinute"
              >
              <span>{{ data.tooltip }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
